import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Trophy } from "lucide-react";
import { api } from "../../lib/api";

export const WinnerSpotlight = () => {
  const [name, setName] = useState("M. SHALHOUT");

  useEffect(() => {
    api
      .get("/winner")
      .then((r) => {
        const n = r.data?.winner?.name;
        if (r.data?.drawn && n) setName(n);
      })
      .catch(() => {});
  }, []);

  return (
    <section
      id="winners"
      className="relative py-24 md:py-36 bg-[#D9D8D2]"
      data-testid="winner-section"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-2xl mx-auto bg-[#FAF9F5] border-2 border-[#111111] rounded-sm shadow-[8px_8px_0px_#111111] overflow-hidden"
          data-testid="winner-spotlight"
        >
          <div className="relative h-44 md:h-56">
            <img
              src="/images/winner-r7.jpg"
              alt="Black Yamaha R7 sportbike parked on open asphalt"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-[#ECECE8]/40" />
            <span className="absolute top-4 left-4 bg-[#FF4500] text-white text-[10px] font-black uppercase tracking-[0.2em] px-3 py-1.5 rounded-sm">
              Community Spotlight // Hall of Fame
            </span>
          </div>
          <div className="p-8 md:p-10 text-center">
            <Trophy className="h-10 w-10 text-[#FF4500] mx-auto" />
            <h3
              className="mt-5 font-display font-black uppercase tracking-tighter text-2xl md:text-4xl text-[#111111]"
              data-testid="winner-name"
            >
              Featured Rider: {name}
            </h3>
            <p className="text-[#555555] mt-3 leading-relaxed">
              Representing the 12 O'Clock crew out on the asphalt. Gear up, tag
              us, and join the hall of fame.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WinnerSpotlight;
